import { customFetch } from "@/client/custom-fetch";

import type { TPaymentGateway } from "./payment-gateways.types";

export const getPaymentGateways = async (includeInactive = false) => {
  const q = includeInactive ? "?all=true" : "";
  return customFetch<TPaymentGateway[]>(`/payment-gateways${q}`);
};

export const getPaymentGateway = async (id: string) => {
  return customFetch<TPaymentGateway>(`/payment-gateways/${id}`);
};

export const createPaymentGateway = async (data: {
  slug: string;
  name: string;
  description?: string | null;
  is_active?: boolean;
  metadata?: Record<string, unknown> | null;
}) => {
  return customFetch<TPaymentGateway>(`/payment-gateways`, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updatePaymentGateway = async (
  id: string,
  data: Partial<{
    slug: string;
    name: string;
    description: string | null;
    is_active: boolean;
    metadata: Record<string, unknown> | null;
  }>,
) => {
  return customFetch<TPaymentGateway>(`/payment-gateways/${id}`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
};

export const deletePaymentGateway = async (id: string) => {
  return customFetch<{ id: string }>(`/payment-gateways/${id}`, {
    method: "DELETE",
  });
};
